<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CS963 printeris">
     CS963 printeris
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_lv" title="Dro&scaron;ības informācija">
     Dro&scaron;ības informācija
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Apzīmējumi">
      Apzīmējumi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e43" title="Paziņojumi saistībā ar produktu">
      Paziņojumi saistībā ar produktu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_lv" title="Informācija par printeri">
     Informācija par printeri
    </a>
   </p>
   <div id="divd0e213">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_lv" title="Informācijas atra&scaron;ana par printeri">
      Informācijas atra&scaron;ana par printeri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_lv" title="Printera sērijas numura atra&scaron;ana">
      Printera sērijas numura atra&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_lv" title="Printera konfigurācijas">
      Printera konfigurācijas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_lv" title="Ja lietojat vadības paneli">
      Ja lietojat vadības paneli
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_lv" title="Sākuma ekrāna ikonas">
      Sākuma ekrāna ikonas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_lv" title="Indikatora gaismas krāsas">
      Indikatora gaismas krāsas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_lv" title="Dro&scaron;ības slota atra&scaron;ana">
      Dro&scaron;ības slota atra&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e715" title="Papīra izvēle">
      Papīra izvēle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10486" title="Printera papildu funkcijas un atbalsts">
      Printera papildu funkcijas un atbalsts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_lv" title="Uzstādī&scaron;ana, instalē&scaron;ana un konfigurē&scaron;ana">
     Uzstādī&scaron;ana, instalē&scaron;ana un konfigurē&scaron;ana
    </a>
   </p>
   <div id="divd0e10604">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_lv" title="Printera atra&scaron;anās vietas izvēle">
      Printera atra&scaron;anās vietas izvēle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_lv" title="Printera porti">
      Printera porti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#d0e10784" title="Lietotņu un risinājumu konfigurē&scaron;ana">
      Lietotņu un risinājumu konfigurē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e10942" title="Pieejamības funkciju iestatī&scaron;ana un lieto&scaron;ana">
      Pieejamības funkciju iestatī&scaron;ana un lieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_lv" title="Papīra un speciālā apdrukājamā materiāla ievieto&scaron;ana">
      Papīra un speciālā apdrukājamā materiāla ievieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11648" title="Programmatūras, draiveru un programmaparatūras uzstādī&scaron;ana un atjauninā&scaron;ana">
      Programmatūras, draiveru un programmaparatūras uzstādī&scaron;ana un atjauninā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e11951" title="Aparatūras ierīču uzstādī&scaron;ana">
      Aparatūras ierīču uzstādī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e13431" title="Tīklo&scaron;ana">
      Tīklo&scaron;ana
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_lv" title="Printera dro&scaron;ība">
     Printera dro&scaron;ība
    </a>
   </p>
   <div id="divd0e13782">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_lv" title="Printera atmiņas dzē&scaron;ana">
      Printera atmiņas dzē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_lv" title="Printera krātuves diska dzē&scaron;ana">
      Printera krātuves diska dzē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_lv" title="Rūpnīcas noklusējuma iestatījumu atjauno&scaron;ana">
      Rūpnīcas noklusējuma iestatījumu atjauno&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_lv" title="Paziņojums par energoatkarību">
      Paziņojums par energoatkarību
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_lv" title="Drukāt">
     Drukāt
    </a>
   </p>
   <div id="divd0e13972">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_lv" title="Drukā&scaron;ana no datora">
      Drukā&scaron;ana no datora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14023" title="Drukā&scaron;ana no mobilās ierīces">
      Drukā&scaron;ana no mobilās ierīces
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_lv" title="Drukā&scaron;ana no zibatmiņas diska">
      Drukā&scaron;ana no zibatmiņas diska
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_lv" title="Konfidenciālu darbu konfigurē&scaron;ana">
      Konfidenciālu darbu konfigurē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_lv" title="Konfidenciālu un citu aizturētu darbu drukā&scaron;ana">
      Konfidenciālu un citu aizturētu darbu drukā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_lv" title="Fontu paraugu saraksta drukā&scaron;ana">
      Fontu paraugu saraksta drukā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_lv" title="Direktoriju saraksta drukā&scaron;ana">
      Direktoriju saraksta drukā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_lv" title="Atdalītāju lok&scaron;ņu ievieto&scaron;ana drukas darbos">
      Atdalītāju lok&scaron;ņu ievieto&scaron;ana drukas darbos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_lv" title="Drukas darba atcel&scaron;ana">
      Drukas darba atcel&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_lv" title="Tonera intensitātes koriģē&scaron;ana">
      Tonera intensitātes koriģē&scaron;ana
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_lv" title="Printera izvēlnes">
     Printera izvēlnes
    </a>
   </p>
   <div id="divd0e14518">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_lv" title="Izvēļņu karte">
      Izvēļņu karte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e14826" title="Ierīce">
      Ierīce
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e16736" title="Drukāt">
      Drukāt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e18017" title="Papīrs">
      Papīrs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e18294" title="USB disks">
      USB disks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e18558" title="Tīkls/porti">
      Tīkls/porti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e20680" title="Dro&scaron;ība">
      Dro&scaron;ība
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e21744" title="Cloud Services">
      Cloud Services
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e21801" title="Atskaites">
      Atskaites
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_lv" title="Problēmu novēr&scaron;ana">
      <strong>
       Problēmu novēr&scaron;ana
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_lv" title="Veidlapu apvieno&scaron;ana">
      <strong>
       Veidlapu apvieno&scaron;ana
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_lv" title="Izvēļņu iestatījumu lapas drukā&scaron;ana">
      <strong>
       Izvēļņu iestatījumu lapas
      </strong>
      drukā&scaron;ana
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_lv" title="Printera apdares opcijas">
     Printera apdares opcijas
    </a>
   </p>
   <div id="divd0e22189">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_lv" title="Apdarinātāja ar skavotāju izmanto&scaron;ana">
      Apdarinātāja ar skavotāju izmanto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_lv" title="Apdarinātāja ar skavotāju un caurumotāju izmanto&scaron;ana">
      Apdarinātāja ar skavotāju un caurumotāju izmanto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_lv" title="Ofseta krāvēja izmanto&scaron;ana">
      Ofseta krāvēja izmanto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_lv" title="Bro&scaron;ūru apdarinātāja izmanto&scaron;ana">
      Bro&scaron;ūru apdarinātāja izmanto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_lv" title="Papīra pārvieto&scaron;anas opcijas izmanto&scaron;ana ar locī&scaron;anas opciju">
      Papīra pārvieto&scaron;anas opcijas izmanto&scaron;ana ar locī&scaron;anas opciju
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_lv" title="Printera uzturē&scaron;ana">
     Printera uzturē&scaron;ana
    </a>
   </p>
   <div id="divd0e22598">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_lv" title="Detaļu un izejmateriālu statusa pārbaude">
      Detaļu un izejmateriālu statusa pārbaude
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_lv" title="Izejmateriālu paziņojumu konfigurē&scaron;ana">
      Izejmateriālu paziņojumu konfigurē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_lv" title="E-pasta brīdinājumu iestatī&scaron;ana">
      E-pasta brīdinājumu iestatī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_lv" title="Atskai&scaron;u un žurnālu ģenerē&scaron;ana">
      Atskai&scaron;u un žurnālu ģenerē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_lv" title="Detaļu un izejmateriālu pasūtī&scaron;ana">
      Detaļu un izejmateriālu pasūtī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e23197" title="Detaļu un izejmateriālu nomaiņa">
      Detaļu un izejmateriālu nomaiņa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e23786" title="Printera detaļu tīrī&scaron;ana">
      Printera detaļu tīrī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e23900" title="Enerģijas un papīra taupī&scaron;ana">
      Enerģijas un papīra taupī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_lv" title="Printera pārvieto&scaron;ana uz citu vietu">
      Printera pārvieto&scaron;ana uz citu vietu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_lv" title="Problēmas novēr&scaron;ana">
     Problēmas novēr&scaron;ana
    </a>
   </p>
   <div id="divd0e24035">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_lv" title="Drukas kvalitātes problēmas">
      Drukas kvalitātes problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_lv" title="Printera kļūdu kodi">
      Printera kļūdu kodi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e25210" title="Drukā&scaron;anas problēmas">
      Drukā&scaron;anas problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_lv" title="Printeris nereaģē">
      Printeris nereaģē
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_lv" title="Nevar lasīt zibatmiņas disku">
      Nevar lasīt zibatmiņas disku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_lv" title="USB porta iespējo&scaron;ana">
      USB porta iespējo&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_lv" title="Iestrēgu&scaron;a papīra izņem&scaron;ana">
      Iestrēgu&scaron;a papīra izņem&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e27191" title="Tīkla savienojuma problēmas">
      Tīkla savienojuma problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e27282" title="Aparatūras ierīču problēmas">
      Aparatūras ierīču problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e27450" title="Izejmateriālu problēmas">
      Izejmateriālu problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e27598" title="Papīra padeves problēmas">
      Papīra padeves problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e27792" title="Krāsas kvalitātes problēmas">
      Krāsas kvalitātes problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_lv" title="Sazinā&scaron;anās ar klientu atbalstu">
      Sazinā&scaron;anās ar klientu atbalstu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_lv" title="Otrreizējā pārstrāde un atbrīvo&scaron;anās">
     Otrreizējā pārstrāde un atbrīvo&scaron;anās
    </a>
   </p>
   <div id="divd0e28016">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_lv" title="Lexmark produktu pārstrāde">
      Lexmark produktu pārstrāde
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_lv" title="Lexmark iepakojuma pārstrāde">
      Lexmark iepakojuma pārstrāde
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_lv" title="Paziņojumi">
     Paziņojumi
    </a>
   </p>
   <div id="divd0e28050">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28053" title="Produkta informācija">
      Produkta informācija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28070" title="Izdevuma paziņojums">
      Izdevuma paziņojums
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_lv" title="Preču zīmes">
      Preču zīmes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_lv" title="Paziņojumi par licencē&scaron;anu">
      Paziņojumi par licencē&scaron;anu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_lv" title="Trok&scaron;ņu emisijas līmeņi">
      Trok&scaron;ņu emisijas līmeņi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_lv" title="Atkritumu savāk&scaron;ana atbilsto&scaron;i Elektrisko un elektronisko iekārtu direktīvai (EEIA)">
      Atkritumu savāk&scaron;ana atbilsto&scaron;i Elektrisko un elektronisko iekārtu direktīvai (EEIA)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28168" title="Litija jonu lādējama baterija">
      Litija jonu lādējama baterija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_lv" title="Regula (EU) 2023/1542">
      Regula (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28205" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_lv" title="Atbrīvo&scaron;anās no produkta">
      Atbrīvo&scaron;anās no produkta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_lv" title="Lexmark kasetņu atgrie&scaron;ana atkārtotai izmanto&scaron;anai un pārstrādei">
      Lexmark kasetņu atgrie&scaron;ana atkārtotai izmanto&scaron;anai un pārstrādei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_lv" title="Paziņojums par jutību pret statisko elektrību">
      Paziņojums par jutību pret statisko elektrību
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_lv" title="Emblēma &ldquo;ENERGY STAR&rdquo;">
      Emblēma &ldquo;ENERGY STAR&rdquo;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_lv" title="Informācija par temperatūru">
      Informācija par temperatūru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_lv" title="Paziņojums par lāzerstarojumu">
      Paziņojums par lāzerstarojumu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_lv" title="Jaudas patēriņ&scaron;">
      Jaudas patēriņ&scaron;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28466" title="Reglamentējo&scaron;i paziņojumi par bezvadu produktiem">
      Reglamentējo&scaron;i paziņojumi par bezvadu produktiem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_lv" title="Modulāra komponenta paziņojums">
      Modulāra komponenta paziņojums
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_lv" title="Radiofrekvences starojuma iedarbība">
      Radiofrekvences starojuma iedarbība
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28491" title="Atbilstība Eiropas Kopienas (EK) direktīvām">
      Atbilstība Eiropas Kopienas (EK) direktīvām
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_lv" title="Atbilstība Eiropas Kopienas (EK) direktīvām">
      Atbilstība Eiropas Kopienas (EK) direktīvām
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_lv" title="Paziņojums par radioviļņu ietekmi">
      Paziņojums par radioviļņu ietekmi
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue